import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { WsService } from '../ws/ws.service';
import { AlertService } from '../alert/alert.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {

  private loginSubscription: Subscription;
  private logoutSubscription: Subscription;
  private smsSubscription: Subscription;
  private stateSubscription: Subscription;
  private connectSubscription: Subscription;
  private LS_SESSION_KEY = 'session';
  public state: any;
  public loginStep: number;
  public errorMessageLogin: any;
  public errorMessageSms: any;
  public ST: any;
  public user: any;
  public wsOnline: boolean;

  public __debugCode: any;

  constructor(private ws: WsService, private alert: AlertService) {
      this.ST = this.ws.ST;
      this.user = null;
      this.loginStep = 1;
      this.errorMessageLogin = null;
      this.errorMessageSms = null;
      this.__debugCode = '';
      this.loginSubscription = this.ws.events.login.subscribe(this.onLogin.bind(this));
      this.logoutSubscription = this.ws.events.logout.subscribe(this.onLogout.bind(this));
      this.smsSubscription = this.ws.events.check_sms.subscribe(this.onCheckSms.bind(this));
      this.stateSubscription = this.ws.onState.subscribe(this.onChangeState.bind(this));
      this.connectSubscription = this.ws.onConnect.subscribe(this.onConnect.bind(this));
      this.state = this.ws.getState();
      this.wsOnline = false;
  };

  public submitLogin(form: NgForm) {
      this.ws.methodLogin(form.value);
  };

  private onLogin(result: any): void {
      if (result.error === 0) {
          this.loginStep = 2;
          if (result.code) {
              console.debug('code = ' + result.code);
              this.__debugCode = result.code;
          }
          if (result.id_session) {
              this.saveSession(result.id_session);
          }
      } else {
          const session = this.readSession();
          if (session) {
              this.dropSession();
          } else {
              this.errorMessageLogin = 'Ошибка авторизации (' + result.error + ')';
          }
      }
  };

  public submitSms(form: NgForm) {
      this.ws.methodCheckSms(form.value);
  };

  private onCheckSms(result: any): void {
      if (result.error === 0) {
      } else {
          this.errorMessageSms = 'Неверный код';
      }
  };

  private onChangeState(state: number): void {
      this.state = state;
      if (this.state === 0) {
          this.loginStep = 1;
      }
  };

  private onLogout(result: any): void {
      if (result.error === 0) {
          this.dropSession();
      }
  };

  private saveSession(session: string): void {
      localStorage.setItem(this.LS_SESSION_KEY, session);
      document.cookie = 'id_session=' + session + '; SameSite=strict';
  };

  private readSession(): any {
      return localStorage.getItem(this.LS_SESSION_KEY);
  };

  private dropSession(): any {
      return localStorage.removeItem(this.LS_SESSION_KEY);
  };

  private onConnect(): any {
      this.wsOnline = this.ws.wsOnline;
      const session = this.readSession();
      if (session && this.ws.wsOnline) {
          this.ws.methodLogin({id_session: session});
      }
  };

  ngOnInit() {
      if (this.ws.wsOnline) {
          this.onConnect();
      }
  }

  ngOnDestroy() {
      this.loginSubscription.unsubscribe();
      this.smsSubscription.unsubscribe();
      this.stateSubscription.unsubscribe();
  };

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts